/**
 * 复制到剪贴板。原本长在 DrawDetailContent 里，验算组件抽出去之后有三个调用方
 * （归档明细、Milhar 验算页、账单抬头的全局期号），迁到这里。
 *
 * @returns 是否复制成功 —— 调用方必须给出可见反馈，**不许静默失败**
 */
export async function copyText(value: string) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // Fall through to the execCommand fallback below — some browsers (older
    // Safari, non-secure contexts) reject or lack navigator.clipboard.
  }
  // Fallback for browsers without (or that refuse) the async Clipboard API:
  // a fixed-position, off-screen, readonly textarea plus the legacy
  // execCommand('copy'). Restored from WalletPage's former private copyText.
  try {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, value.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
